import ReCAPTCHA from "react-google-recaptcha";
import { CAPTCHA_SITE_KEY, CURRENT_LANGUAGE } from "../../../utils/constants";
import { Alert } from "~/common/m3/Alert/Alert";

interface RecaptchaWidgetProps {
  onChange(value: string | null): void;
  error: string;
  size?: "compact" | "normal" | "invisible";
}

const RecaptchaWidget = (props: RecaptchaWidgetProps) => {
  return (
    <div className={"recaptcha-widget"}>
      <ReCAPTCHA sitekey={CAPTCHA_SITE_KEY} onChange={props.onChange} hl={CURRENT_LANGUAGE} size={props.size} />
      {props.error && (
        <Alert className={"my-2"} severity={"error"}>
          {props.error}
        </Alert>
      )}
    </div>
  );
};

export default RecaptchaWidget;
